define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/riq-api-formatter/1.0.0/index',
  'core_client_library/js/enterprise-js/0.6.0/map-object-keys/1.0.0/index',
  'readingiq-src/js/string-utils/1.0.0/index'
], function riqApiServiceImpl(
  aoflModules,
  riqApiFormatter,
  mapObjectKeys,
  stringUtils
) {
  'use strict';

  var snakeCase = stringUtils.snakeCase;
  var camelCase = stringUtils.camelCase;
  var resourceEnumerate = aoflModules.resourceEnumerate;
  var apiRequest = aoflModules.apiRequest;
  var storeService = aoflModules.store;

  var riqApiService = function riqApiService(
    riqErrorHandlerService,
    $rootScope,
    $timeout
  ) {
    var _this = this;
    var _errFn = riqErrorHandlerService.getErrorFactory('riqApiService');
    /**
     * Mapping endpoints
     * @type {Object}
     **/
    var API_ENDPOINT_KEYS = {
      logEvent: 'event_log',
      sendEvent: 'event_send',
      getShelves: 'library_get',
      resourceEnumerate: 'resource_enumerate',
      getBooks: 'collection_get',
      getRecommendedBooks: 'collection_get_next_items',
      getProfile: 'profile_get',
      updateProfile: 'profile_update',
      swapProfile: 'profile_swap',
      login: 'account_login',
      logoutUser: 'user_logout', // Marketing Endpoint
      validateToken: 'account_validate',
      getClassroomDailyProgress: 'classroom_get_daily_progress',
      validateSession: 'session_validate',
      processNewsfeed: 'newsfeed_process_log',
      getUser: 'user_get',
      sendInvitations: 'invitation_send',
      optInTeacherRewards: 'teacher_rewards_opt_in',
      getFeatures: 'feature_get'
    };
    var postPromises = {};

    apiRequest.addFormatter('readingIqPackager', riqApiFormatter);

    /**
     * Set api endpoints
     * @function setApiEndpoints
     * @param {Object} _apiEndpoints Map of actions to API keys
     */
    _this.setApiEndpoints = function setApiEndpoints(_apiEndpoints) {
      Object.assign(API_ENDPOINT_KEYS, _apiEndpoints);
    };

    var _onRequestSuccess = function _onRequestSuccess(data) {
      const state = storeService.getState();
      const currentToken = state.appSession.token;
      const appSessionId = state.appSession.appSessionId;
      const commits = [];
      if (data.token && currentToken !== data.token) {
        localStorage.setItem('riqAuthToken', data.token);
        commits.push({
          stateAlias: 'appSession',
          mutationId: 'setToken',
          payload: data.token
        });
      }
      if (data.app_session_id && appSessionId !== data.app_session_id) {
        commits.push({
          stateAlias: 'appSession',
          mutationId: 'setAppSessionId',
          payload: data.app_session_id
        });
      }
      if (commits.length > 0) storeService.commit(commits);
      return mapObjectKeys.mapKeys(camelCase)(data.payload);
    };

    var _onRequestError = function _onRequestError(error) {
      // Check if it's a javascript or an API error, better implementation is to check for the format of the api error.
      var _err =
        error instanceof Error
          ? error
          : mapObjectKeys.mapKeys(camelCase)(error);

      riqErrorHandlerService.handle(_err);
      return Promise.reject(_err);
    };

    var _createRiqFetcher = function _createRiqFetcher(
      apiResourcesNS,
      packagerFormat,
      _transformArgFn
    ) {
      return function riqFetch(_action, _data, _cache) {
        var state = storeService.getState();
        var payload = {
          token: state.appSession.token,
          deviceId: state.appSession.deviceId,
          args: _transformArgFn(_data)
        };
        return _this
          .getEndpointUrl(apiResourcesNS, _action)
          .then(url => apiRequest.request(url, payload, packagerFormat, _cache))
          .then(_onRequestSuccess)
          .catch(_onRequestError);
      };
    };

    _this.getEndpointUrl = function getEndpointUrl(apiResourcesNS, action) {
      return resourceEnumerate.get(apiResourcesNS).then(function(data) {
        if (apiResourcesNS === 'readingIq') {
          $rootScope.cdnBaseUrl =
            data.payload.api_domains.cdn_base_url +
            '/' +
            data.payload.api_domains.cdn_prefix;
        }
        var endpointPath =
          data.payload.api_endpoints[API_ENDPOINT_KEYS[action]];
        if (!endpointPath) {
          throw _errFn(
            'EndPointNotFnd',
            '{action} Endpoint url is not found in  {apiResourcesNS} apiResources',
            {action, apiResourcesNS}
          );
        }
        return data.payload.api_domains.api_root_url + endpointPath;
      });
    };

    const wrapApiArgs = _data => [_data || {}];
    const snakeCaseApiArgs = _data =>
      wrapApiArgs(mapObjectKeys.mapKeys(snakeCase)(_data));

    /**
     * Execute fetch request
     * @function get
     * @param {String} _action - endpoint shortcut
     * @param {Object} _data - payload
     * @param {Boolean} [_cache=false] - do refresh request
     * @return {Promise} promise
     **/
    _this.get = _createRiqFetcher(
      'readingIq',
      'readingIqPackager',
      snakeCaseApiArgs
    );

    _this.post = (action, _data) => _this.get(action, _data, false);

    _this.debouncedPost = (action, _data, bounceMilliseconds) => {
      if (typeof bounceMilliseconds === 'number') {
        var promiseKey = action + '|' + JSON.stringify(_data);
        var postPromise = postPromises[promiseKey];
        if (!postPromise) {
          postPromise = postPromises[promiseKey] = _this.get(
            action,
            _data,
            false
          );
          $timeout(() => {
            delete postPromises[promiseKey];
          }, bounceMilliseconds);
        }
        return postPromise;
      }
      return _this.get(action, _data, false);
    };

    _this.getMarketing = _createRiqFetcher(
      'marketing',
      'readingIqPackager',
      snakeCaseApiArgs
    );

    _this.userGet = function(action, _data, _cache) {
      // @TODO: revisit how we get the profileUuid?
      var profileUuid = storeService.getState().profile.profileUuid;
      var args = Object.assign({}, _data, {
        profileUuid: profileUuid
      });
      return _this.get(action, args, _cache);
    };

    /**
     * Used for to send 3rd Party Data to ReadingIQ API
     */
    _this.postExternalData = _createRiqFetcher(
      'readingIq',
      'readingIqPackager',
      wrapApiArgs
    );

    return _this;
  };

  return riqApiService;
});
